import { DeviceGroup, RateStatus } from '@quadminds/shared/route-cost';

export interface IRateVariableOutputDto {
    id?: string;
    rateId?: string;
    from: string;
    to?: string;
}

export interface IRateSchema {
    id?: string;

    name?: string;

    code?: string;

    status?: RateStatus;

    organizationId?: string;

    deviceGroups?: DeviceGroup[];

    carrierExternalIds?: string[];

    tripTypes?: string[];

    variables?: IRateVariableOutputDto[];
}
